// =====================================================
// Đường dẫn đầy đủ tới tệp trong thư mục uploads
// File: web-app/src/utils/fileUrl.js
//
// Máy chủ phục vụ thư mục /uploads ở GỐC, còn API nằm ở /api.
// Nếu ghép thẳng địa chỉ API vào sẽ thành /api/uploads/... -> ảnh không hiện.
// =====================================================
export const fileUrl = (u) => {
    if (!u) return null;
    if (/^(https?:|data:|blob:)/i.test(u)) return u;
    const api = process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5000/api`;
    const base = api.replace(/\/api\/?$/, '');   // chỉ bỏ /api ở CUỐI, không bỏ giữa chừng
    return base + (u.startsWith('/') ? u : '/' + u);
};

export default fileUrl;
